import { createClassComponent } from 'lib/preactHelpers'
import './index.sass'

const ParallelContentBoxes = createClassComponent('ParallelContentBoxes')
export default ParallelContentBoxes
